import { AuthStore } from "./auth/AuthStore";
import { OnboardingStore } from "./onboarding/OnboardingStore";
import { NavigationStore } from "./navigation/NavigationStore";
import { QuestionnaireStore } from "./questionnaire/QuestionnaireStore";

export class RootStore {
  authStore: AuthStore;
  onboardingStore: OnboardingStore;
  navigationStore: NavigationStore;
  questionnaireStore: QuestionnaireStore;

  constructor() {
    this.authStore = new AuthStore();
    this.onboardingStore = new OnboardingStore();
    this.navigationStore = new NavigationStore();
    this.questionnaireStore = new QuestionnaireStore();
  }

  reset() {
    this.authStore.logout();
    this.onboardingStore.resetOnboarding();
  }
}
